<template>
  <ul v-if="sectionShowable" class="main_navigation" @click="emitNavigationClick">
    <navigation-item
        v-for="item in items"
        :key="item.id"
        :class-name="item.className"
        :link-name="item.linkName"
        :section-name="item.sectionName"
        :routes="item.routes"
        :sub-pages="item.subPages"
        @clicked="emitNavigationClick"
        @clickOpen="emitClickOpen"
        :ref="getItemRefId(item.id)"
    >{{ item.title }}
    </navigation-item>
  </ul>
</template>

<script>
import NavigationItem from "@/components/NavigationItem"

export default {
  name: "navigation",
  components: {NavigationItem},
  props: {
    items: Array,
  },
  data(){
    return {
      sectionShowable: true,
    }
  },
  mounted() {
    this.sectionShowable = false;
    this.items.forEach(function (item){
      if(this.$refs[this.getItemRefId(item.id)][0].isShowable()){
        this.sectionShowable = true;
        return;
      }
    }.bind(this));
  },
  methods: {
    emitNavigationClick(type) {
      this.$emit('navigationClick', type)
    },
    emitClickOpen() {
      this.$emit('clickOpen')
    },
    closeIfNotActive() {
      this.items.forEach(function (item) {
        if (this.$refs[this.getItemRefId(item.id)][0]) {
          this.$refs[this.getItemRefId(item.id)][0].closeIfNotActive()
        }
      }.bind(this))
    },
    getItemRefId(id) {
      return 'nav-item-' + id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue